import { Dispatch } from 'redux';

import { TariffApi, ResponseError } from '@swagger-http';

import { Scope } from '@tools/enums';
import { SpotPriceActionTypes } from './enums';
import {
    handleError,
    checkForScopes,
    createRequestConfiguration,
} from '@tools/utils';

export const getSpotPrice =
    () =>
    async (dispatch: Dispatch<any>): Promise<void> => {
        if (!checkForScopes([Scope.TARIFF_READ])) {
            return;
        }

        dispatch({
            type: SpotPriceActionTypes.SET_USER_SPOT_PRICE_DATA,
            payload: {
                data: null,
                error: null,
                loading: true,
            },
        });

        try {
            const data = await new TariffApi(
                createRequestConfiguration(),
            ).tariffGetSpotPrice();

            dispatch({
                type: SpotPriceActionTypes.SET_USER_SPOT_PRICE_DATA,
                payload: {
                    data,
                    error: null,
                    loading: false,
                },
            });
        } catch (e) {
            const status = (e as ResponseError)?.response?.status;

            dispatch({
                type: SpotPriceActionTypes.SET_USER_SPOT_PRICE_DATA,
                payload: {
                    data: null,
                    error: status || 500,
                    loading: false,
                },
            });

            if (status !== 404) {
                await handleError(e, 'Unable to get spot price:');
            }
        }
    };
